import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerServiceWorker } from './serviceWorkerRegistration';
import { warmupApi } from './services/startupHealth';

// Start the backend wake-up in parallel with React boot. It is intentionally
// fire-and-forget so a slow/unreachable API never blocks the UI from rendering.
warmupApi();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
